import { WIDGET_VERSION } from './constants';
import type { WidgetConfig, WidgetInstance } from './types';
import { createWidget } from './widget';

// Named exports only — vite.config.widget.ts uses `output.exports: 'named'` so
// the IIFE bundle exposes them as `window.RHApartmentWidget.init` / `.version`
// without an awkward `.default` indirection.
export const version = WIDGET_VERSION;

export function init(config: WidgetConfig): WidgetInstance {
  return createWidget(config);
}

export { createWidget };

export type { WidgetConfig, WidgetInstance } from './types';

// Auto-init: any element carrying both `data-customer-id` and `data-rh-autoinit`
// gets bootstrapped on DOMContentLoaded so simple drop-in embeds work without
// a manual `init()` call. Elements that only have `data-customer-id` are left
// alone — callers may still want to add their own onReady/onError callbacks.
function autoInit(): void {
  const nodes = document.querySelectorAll<HTMLElement>(
    '[data-rh-autoinit][data-customer-id]',
  );
  nodes.forEach((node) => {
    if (node.dataset.rhInitialized === '1') return;
    try {
      const inst = createWidget({
        container: node,
        customerId: node.dataset.customerId as string,
      });
      node.dataset.rhInitialized = '1';
      (node as HTMLElement & { __rhWidget?: WidgetInstance }).__rhWidget = inst;
    } catch (err) {
      console.error('[RHApartmentWidget] auto-init failed:', err);
    }
  });
}

if (typeof window !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoInit, { once: true });
  } else {
    autoInit();
  }
}
